import { useCallback, useEffect, useMemo, useState } from 'react';
import {
  PaginatedClientResponseModelAccessRequestTemplateClientModel,
  useListAccessRequestTemplates,
  API_LIMIT,
} from '@apono/client-app-sdk';
import { useSearchParams } from 'react-router-dom';
import { PAGE_PARAM } from '@common/constants';

export default function useTemplatesTable() {
  const [queryParams, setQueryParams] = useSearchParams();
  const [pageData, setPageData] = useState<PaginatedClientResponseModelAccessRequestTemplateClientModel | undefined>();

  const pageParam = useMemo(() => {
    return (parseInt(queryParams.get(PAGE_PARAM) || '1') - 1) * API_LIMIT;
  }, [queryParams]);

  const { data, fetchNextPage, isFetchingNextPage, isFetched } = useListAccessRequestTemplates({});

  useEffect(() => {
    if (!data) return;

    const pageParamIndex = data.pageParams.findIndex((p) => p === pageParam);
    if (pageParamIndex === -1 && pageParam > 0) {
      fetchNextPage({ pageParam });
    } else {
      setPageData(data.pages[pageParamIndex]);
    }
  }, [data, fetchNextPage, pageParam]);

  const handleOnPageChange = useCallback(
    (newPage: number) => {
      queryParams.set(PAGE_PARAM, String(newPage));
      setQueryParams(queryParams);
    },
    [setQueryParams, queryParams],
  );

  return {
    isFetched,
    isLoading: isFetchingNextPage,
    pageData,
    handleOnPageChange,
  };
}
